"use client";

import { motion } from "framer-motion";
import * as Accordion from "@radix-ui/react-accordion";
import { Plus, ArrowRight } from "lucide-react";
import Link from "next/link";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

const faqs = [
  {
    question: "Ist die App wirklich kostenlos?",
    answer:
      "Ja, absolut. ncrechner ist vollständig kostenlos: ohne versteckte Kosten, ohne In-App-Käufe und ohne Abo. Wir glauben, dass jeder Studieninteressierte kostenlosen Zugang zu diesen wichtigen Informationen haben sollte.",
  },
  {
    question: "Für welche Studiengänge kann ich meine Chancen berechnen?",
    answer:
      "Mit ncrechner kannst du deine Zulassungschancen für Humanmedizin, Zahnmedizin, Tiermedizin und Pharmazie berechnen. Wir decken alle öffentlichen deutschen Hochschulen ab, die diese Studiengänge anbieten.",
  },
  {
    question: "Wie aktuell sind die Daten?",
    answer:
      "Wir aktualisieren die Zulassungswerte regelmäßig nach jedem Vergabeverfahren. Die angezeigten NC-Werte basieren auf den offiziellen Daten der letzten Zulassungsrunde. Bitte beachte, dass die tatsächlichen Werte von Semester zu Semester variieren können.",
  },
  {
    question: "Was ist der TMS-Rechner?",
    answer:
      "Der TMS-Rechner (Test für medizinische Studiengänge) wurde in Zusammenarbeit mit Werner Zurowetz von tmsbuddies entwickelt. Er hilft dir, deinen Zielpunktestand für den TMS zu ermitteln und zu verstehen, welchen Score du benötigst, um deine Chancen an bestimmten Hochschulen zu verbessern.",
  },
  {
    question: "Gibt es eine Webversion?",
    answer:
      "Aktuell ist ncrechner als App für iOS und Android verfügbar. Eine Webversion befindet sich in Planung. Folge uns auf unseren Social-Media-Kanälen, um über neue Entwicklungen informiert zu bleiben.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="cv-auto bg-paper py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={stagger(0.09)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="flex flex-col gap-5 mb-12"
        >
          <motion.p
            variants={fadeUp}
            className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-ink-faint"
          >
            <span className="w-1.5 h-1.5 bg-accent shrink-0" aria-hidden="true" />
            FAQ
          </motion.p>
          <motion.h2
            variants={fadeUp}
            className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1] text-ink"
          >
            Häufige Fragen
          </motion.h2>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
        >
          <Accordion.Root type="single" collapsible>
            {faqs.map(({ question, answer }, i) => (
              <Accordion.Item
                key={i}
                value={`item-${i}`}
                className="border-t border-line last:border-b"
              >
                <Accordion.Header>
                  <Accordion.Trigger className="group flex w-full items-center justify-between gap-6 py-6 text-left cursor-pointer">
                    <span className="font-display font-semibold text-lg text-ink group-hover:text-accent group-data-[state=open]:text-accent transition-colors duration-200">
                      {question}
                    </span>
                    <Plus
                      size={18}
                      className="shrink-0 text-ink-faint transition-transform duration-300 group-data-[state=open]:rotate-45 group-data-[state=open]:text-accent"
                      aria-hidden="true"
                    />
                  </Accordion.Trigger>
                </Accordion.Header>
                <Accordion.Content forceMount className="accordion-content">
                  <p className="pb-6 pr-10 text-ink-soft leading-relaxed">{answer}</p>
                </Accordion.Content>
              </Accordion.Item>
            ))}
          </Accordion.Root>

          <Link
            href="/faq/"
            className="inline-flex items-center gap-2 mt-8 text-sm font-semibold text-accent hover:text-accent-deep transition-colors duration-200 group cursor-pointer"
          >
            Alle Fragen ansehen
            <ArrowRight size={15} className="group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
